<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="1500">
      <div class="bg-white">
        <v-data-table :headers="headers" :items="adjuntos" hide-actions item-key="id" no-data-text="No hay datos disponibles"
                          no-results-text="No se encontraron registros que coincidan" light ref="table" disable-initial-sort
                          class="elevation-1 custom-font-regular blue-table-header white-text-table-header dense-table-header mt-3">
          <template slot="items" slot-scope="props">
            <tr @click="confirmToggleAdjunto(props)" :class="[{ 'selected-row' : props.expanded }, 'mouse-pointer']">
              <td class="text-xs-left">{{ props.item.tipoAdjunto }}</td>
              <td class="text-xs-right">
                <v-tooltip bottom>
                  <v-chip color="red" label small v-if="props.item.tieneNotificaciones"
                          slot="activator">!</v-chip>
                  <span>Tiene comentarios nuevos sin leer</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-chip color="yellow" label small v-if="props.item.opcional"
                          slot="activator">OPCIONAL</v-chip>
                  <span>Este requerimiento es opcional</span>
                </v-tooltip>
                {{ props.item.estado }}
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
          <attachment-informe :adjunto="props.item" @updatedAdjuntos="$emit('updatedAdjuntos')" :key="keyAttachmentInforme" ref="attachmentInforme"/>
          </template>
        </v-data-table>
        <v-btn color="primary" @click="confirmVolver">Volver</v-btn>
      </div>
    </v-dialog>
    <v-badge dot overlap left color="red" slot="activator">
      <span slot="badge" v-if="tieneNotificaciones">!</span>
        <v-btn @click="abrirModal" color="primary">
          Adjuntos
        </v-btn>
    </v-badge>
    <ConfirmationDialog ref="confirm" :function-yes="bindingFunction" text="¿Salir sin guardar los cambios?"></ConfirmationDialog>
  </div>
</template>
<script>

import AttachmentInforme from './AttachmentInforme'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'

export default {
  props: {
    adjuntos: [Array, Object]
  },
  components: {
    AttachmentInforme,
    ConfirmationDialog
  },
  data () {
    return {
      headers: [
        { text: 'Nombre', value: 'nombre', sortable: false },
        { text: 'Estado', value: 'estadoDisplay', align: 'right', sortable: false }
      ],
      estados: [],
      currentStatus: '',
      bindingFunction: null,
      dialog: false,
      savingAlert: false,
      keyAttachmentInforme: 1,
      currentProp: null
    }
  },
  computed: {
    tieneNotificaciones () {
      return this.adjuntos.some(adjunto => adjunto.tieneNotificaciones)
    }
  },
  methods: {
    abrirModal () {
      this.dialog = true
    },
    cerrarModal () {
      this.dialog = false
    },
    tieneCambiosSinGuardar () {
      if (this.$refs.attachmentInforme) {
        return this.$refs.attachmentInforme.tieneCambiosSinGuardar()
      }
      return false
    },
    confirmVolver () {
      this.bindingFunction = this.cerrarModal
      if (this.isExpanded() && this.tieneCambiosSinGuardar()) {
        this.$refs.confirm.openDialog()
      } else {
        this.cerrarModal()
      }
    },
    isExpanded () {
      const attachmentsArray = Object.entries(this.$refs.table.expanded)
      return attachmentsArray.some(attachment => attachment[1])
    },
    confirmToggleAdjunto (props) {
      this.currentProp = props
      this.bindingFunction = this.toggleAdjunto

      if (this.isExpanded() && this.tieneCambiosSinGuardar()) {
        this.$refs.confirm.openDialog()
      } else {
        this.toggleAdjunto()
      }
    },
    toggleAdjunto () {
      this.currentProp.expanded = !this.currentProp.expanded
    },
    resetComponent () {
      this.keyAttachmentInforme += 1
    }
  }
}
</script>
<style scoped>
  .bg-white {
    background-color: white !important;
  }
  .mouse-pointer {
    cursor: pointer;
  }
</style>
